import { signal } from 'services/SignalsService'

const name = 'REEL-SPIN'

async function execute() {
  signal.dispatch('GAMBLE-FEATURE:HIDE-BUTTON')
  return signal.promise('REELS-STOP')
}

export function getReelSpinAction() {
  return {
    name,
    execute,
  }
}
